import React, {ReactNode} from 'react';
import {
  FilterGroup,
  HeaderConfig,
  Row,
} from 'components/Table/KhulaSupplierTable';
import {ISupportCustomer} from 'constants/interfaces';

/**
 * Build row headers for KhulaSupplierTable.
 * @param {boolean} isKhulaAdmin - Whether the current user is a Khula admin
 * @return {Array.<HeaderConfig>} Table headers matching the required shape
 */
export const customerTableHeaders = (isKhulaAdmin: boolean): HeaderConfig[] => [
  {
    field: 'farmerFullName',
    title: 'Farmer',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'farmName',
    title: 'Farm Name',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'farmHectares',
    title: 'Hectares',
    isSortable: true,
    isSearchable: false,
  },
  {
    field: 'farmProvince',
    title: 'Province',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'farmAddress',
    title: 'Address',
    isSortable: true,
    isSearchable: true,
  },
  isKhulaAdmin
    ? {
        field: 'farmerAccepted',
        title: '',
        isSortable: false,
        isSearchable: false,
      }
    : {
        field: 'farmerAccepted',
        title: 'Accepted',
        isSortable: true,
        isSearchable: false,
      },
];

// Default sort by the "Farmer" column
export const customerTableDefaultSortField = 'farmerFullName';

// If you have filters, define them here; empty for now
export const customerTableFilters: FilterGroup[] = [];

/**
 * Build row data for KhulaSupplierTable.
 * @param {Array.<ISupportCustomer>} customers - Customers to render in the table
 * @param {boolean} isKhulaAdmin - Whether the current user is a Khula admin
 * @return {Array.<Row>} Table rows matching the required Row shape
 */
export const customerTableRows = (
  customers: ISupportCustomer[],
  isKhulaAdmin: boolean,
): Row[] =>
  customers.map((customer) => ({
    // Remove the spread of customer — do NOT do ...customer here
    id: customer.farmer.id,
    farmerFullName: `${customer.farmer.name} ${customer.farmer.surname}`,
    farmName: customer.farmer.farm?.name || '',
    farmHectares: customer.farmer.farm?.sizeHectares || '',
    farmProvince: customer.farmer.farm?.province || '',
    farmAddress: customer.farmer.address || '',
    ...(isKhulaAdmin
      ? {
          farmerAccepted: !customer.farmer.user?.verified
            ? ((<UnverifiedChip />) as ReactNode)
            : '',
        }
      : {farmerAccepted: customer.farmerAccepted ? 'Yes' : 'No'}),
  }));

const UnverifiedChip = () => (
  <div className="unverified-chip">User unverified</div>
);
